import { render, staticRenderFns } from "./userBasicInfo.vue?vue&type=template&id=27480b19&scoped=true"
import script from "./userBasicInfo.vue?vue&type=script&lang=js"
export * from "./userBasicInfo.vue?vue&type=script&lang=js"
import style0 from "./userBasicInfo.vue?vue&type=style&index=0&id=27480b19&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27480b19",
  null
  
)

export default component.exports